import http from '@lib/http';
import { GetServerSidePropsContext } from 'next';

const getGrayConfig = (ctx?: GetServerSidePropsContext) =>
  http.get('/events', '/api/rainbow', {}, ctx, false);

export default getGrayConfig;
